var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 29 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M.8 9.303c0-.467 0-.7.02-.898A4 4 0 0 1 4.404 4.82c.197-.02.443-.02.936-.02.19 0 .284 0 .365-.004a2.67 2.67 0 0 0 2.313-1.667c.03-.075.058-.16.114-.328.056-.169.085-.253.115-.328A2.67 2.67 0 0 1 10.56.805C10.64.8 10.73.8 10.908.8h6.45c.178 0 .267 0 .348.005a2.67 2.67 0 0 1 2.313 1.667c.03.075.058.159.114.328s.085.253.115.328a2.67 2.67 0 0 0 2.313 1.667c.08.005.175.005.365.005.492 0 .738 0 .935.02a4 4 0 0 1 3.586 3.585c.02.197.02.43.02.898v10.43c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.749 1.748c-.855.436-1.975.436-4.215.436H7.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C.8 23.093.8 21.973.8 19.733z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M14.133 20.133a5.333 5.333 0 1 0 0-10.667 5.333 5.333 0 0 0 0 10.667"
  })));
};
export default SvgCamera;